export const SET_GENERAL_INFORMATION = 'SET_GENERAL_INFORMATION';
